<template>
  <el-dialog
    :visible.sync="value"
    width="30%"
    :show-close="false"
    @close="closeDialog"
  >
    <template v-slot:title>
      <h3>Attach Image</h3>
    </template>
    <template>
      <el-row>
        <el-form ref="selectForm" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="uploadOptions">
                <span slot="label">
                  Select Image Option
                </span>
                <el-select v-model="settings.selectedOption">
                  <el-option
                    v-for="q in uploadOptions"
                    :label="q.label"
                    :key="q.value" :value="q.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="settings.selectedOption === 'link'">
            <el-col :span="24">
              <el-form-item prop="settings.inputLink">
                <span slot="label">
                  Image Link
                </span>
                <el-input
                  placeholder="Please input url"
                  v-model="settings.inputLink"
                  clearable>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-else-if="settings.selectedOption === 'upload'">
            <el-col :span="24">
              <el-upload
                drag
                action=""
                :headers="uploadHeaders"
                :accept="accept"
                :before-upload="beforeUpload"
                :file-list="fileList">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                <span class="fs-11px"><i class="el-icon-info"></i> Files must be 10mb or less</span>
              </el-upload>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
    </template>
    <template slot="footer" class="dialog-footer">
      <el-button @click="$emit('input', false)">Cancel</el-button>
      <el-button type="primary" @click="submitFile" v-if="settings.inputLink.length != 0">Submit</el-button>
    </template>
  </el-dialog>
</template>
<script>
import commsFileUpload from '@/mixins/comms-file-upload';

export default {
  props: ['value'],
  mixins: [commsFileUpload],
  data() {
    return {
      dialogVisible: false,
      activeName: 'first',
      settings: {
        selectedOption: 'link',
        inputLink: '',
        fileList: []
      },
      uploadOptions: [
        {
          label: 'Link', value: 'link',
        },
        {
          label: 'Upload', value: 'upload',
        }
      ]
    };
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    },
    submitFile() {
      this.$emit('input', false);
      this.$emit('addImage', this.settings.inputLink);
    }
  }
};
</script>
